import React, { useState } from 'react'
import leftarrow from "../../../assets/images/left-arrow.svg";
import ResetPassJson from "./newPassword.json";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import styles from './newPassword.module.css';
import eyeiconunfold from "../../../assets/images/eyeiconunfold.svg";
import eyeIcon from "../../../assets/images/eyeicon.svg";
import { Footer } from '../../common/footer/footer';
const NewPaawordJsx = (props) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [showPassword, setShowPassword] = useState({});

  const toggleShowPassword = (fieldName) => {
    setShowPassword(prevState => ({
      ...prevState,
      [fieldName]: !prevState[fieldName]
    }));
  };

  let {
    formData,
    onInputChangeHandler,
    onTouchHandler,
    formSubmitButtonDisable,
    formError,
    formSubmitHandler,
  } = props;

  return (
    <>
      <section className="mainloginscreen">
        <div className="container">
         
        <div className={`${styles.mainloginscreeninner}`}>
        <div className={`${styles.leftsightbackdetails} d-flex`}>
        <div className="d-flex plaindetailsleft align-items-center justify-content-center">
                <div className="back_btn" onClick={() => history.goBack()}><img src={leftarrow} alt={'icon'} /></div>
                                  <h1>{t("NEWPASSWORD.TITLE")}</h1>
                </div>
              </div>
            </div>
            <div className={`${styles.formsection}`}>
            <div className={`${styles.institutelogintext}`}>
            
                  {
                    localStorage.getItem('flowName') === 'login' ?
                      <>
                        <h2 className="h2_style">{t("NEWPASSWORD.CHANGEPASS")}</h2>
                        <h4 className="text-center">{t("NEWPASSWORD.HACKERSTAY")}</h4>
                      </>
                      : <>

                        <h2 className="h2_style text-center">{t("NEWFORGOTPASSWORD.TITLE")} {t("NEWFORGOTPASSWORD.CHANGEPASSSPAN")} {t("NEWFORGOTPASSWORD.CHANGEPASSAFTER")}</h2>
                        <h4 className="text-center">{t("NEWFORGOTPASSWORD.TAGLINE")}</h4>
                      </>
                  }

                  {
                    localStorage.getItem('flowName') === 'login' ?
                      <>
                        <h4 className="text-center">{t("NEWPASSWORD.CHECKEMAIL")}</h4>
                      </>
                      : <>

                        <h5 className="h5_style martop30">&nbsp;</h5>
                      </>
                  }
                  <div className={`${styles.formsectioninner}`}>
                  <div className="ft-inner otpauthentication">
                    {ResetPassJson.map((item, i) => (
                      <>
                        <div className={`input-container form-group ${styles.formfield}`}>
                        <div className={`${styles.small}`}>{t(`${item.label}`)}</div>
                          <input
                            type={showPassword[item.name] ? "text" : "password"}
                            className={
                              item.isRequired && formError[item.name]
                                ? "input form-control  is-invalid"
                                : "input form-control"
                            }
                            id={item.name}
                            name={item.name}
                            placeholder={t(`${item.label}`)}
                            defaultValue={formData[item.name]}
                            onChange={onInputChangeHandler}
                            onBlur={onTouchHandler}
                            maxLength={item.maxLength}
                          />
                     
                          <div className={`${styles.form_image}`} onClick={() => toggleShowPassword(item.name)}>
                            {
                              showPassword[item.name] ? (
                                <img alt="Hide password" src={eyeiconunfold} />
                              ) : (
                                <img alt="Show password" src={eyeIcon} />
                              )
                            }
                          </div>
                       
                          <span className="h6 text-danger">
                            {item.isRequired &&
                              formError[item.name] &&
                              (formError[item.name] === "req"
                                ? t(item.error)
                                : (formError[item.name] === "regx") ? t(item.type_error) : "Password did not match")}
                          </span>
                        </div>

                      </>
                    ))}
                  <div className="d-flex align-items-center justify-content-center"> <button type="submit"
                      className={(formSubmitButtonDisable) ? " mt-4 mainbutton"
                        : "mt-3 mainbutton"}
                      disabled={formSubmitButtonDisable}
                      onClick={formSubmitHandler}>{t("NEWPASSWORD.CONTINUE")}</button></div> 

                  </div>
                  <div className={`${styles.passtext} mt-4`}>
                    <h4>{t("NEWPASSWORD.FARFROMHACKER")} </h4>
                    <h4>{t("NEWPASSWORD.STRONGPASSWORD")}</h4>
                    <ul className="mt-3">
                      <li>{t("NEWPASSWORD.CHARACTER")}</li>
                      <li>{t("NEWPASSWORD.ONENUMBER")}</li>
                      <li>{t("NEWPASSWORD.SPECIALCHAR")}</li>
                      <li>{t("NEWPASSWORD.UPPERCHAR")}</li>
                    </ul>
                  </div>
                </div>
              
              </div>

            </div>
            <Footer />
        </div>
      </section>
      <ToastContainer />


    </>

  );
};

export default NewPaawordJsx;
